import { useEffect, useRef } from 'react'

import { useToast } from '@/hooks'
import {
  BANKRUPTCY_SCREENING_STATUSES,
  BANKRUPTCY_STATUSES,
} from '@/modules/tools/bankruptcy/constants'

// Polling swaps the results in silently, so announce the moment screening stops.
export const useScreeningOutcomeToast = (status?: string) => {
  const { successToast, errorToast } = useToast()
  const previousStatus = useRef(status)

  useEffect(() => {
    const wasScreening =
      !!previousStatus.current &&
      BANKRUPTCY_SCREENING_STATUSES.includes(previousStatus.current)
    previousStatus.current = status

    if (!wasScreening || !status) return
    if (BANKRUPTCY_SCREENING_STATUSES.includes(status)) return

    if (status === BANKRUPTCY_STATUSES.failed) {
      errorToast('Screening failed', 'We could not read this case.')
      return
    }
    successToast('Screening complete', 'The results are on the case page.')
  }, [status])
}
